/**
 * Injects theme CSS into shadow roots inside .footer-ethic-app-form
 * so app block forms (e.g. Shopify Forms) match the theme.
 */
(function() {
  var wrapperSelector = '.footer-ethic-app-form, [data-app-form-wrapper]';

  function getThemeVars(el) {
    var root = document.documentElement;
    var s = el ? getComputedStyle(el) : getComputedStyle(root);
    return {
      foreground: s.getPropertyValue('--foreground-color').trim() || 'black',
      background: s.getPropertyValue('--background-color').trim() || 'white',
      gray: s.getPropertyValue('--gray-color').trim() || '#A3A3A3',
      fontFamily: s.getPropertyValue('--font-family').trim() || 'inherit',
      fontSize: s.getPropertyValue('--font-size').trim() || '14px',
      lineHeight: s.getPropertyValue('--font-line-height').trim() || '21px',
      bigMargin: s.getPropertyValue('--big-margin').trim() || '2rem',
      margin: s.getPropertyValue('--margin').trim() || '1rem',
      smallMargin: s.getPropertyValue('--small-margin').trim() || '0.5rem',
    };
  }

  function buildInjectedCSS(vars) {
    return [
      ':host {',
      '--inline-container-max-width: none !important;',
      '--container-background-color: transparent !important;',
      '--form-background-color: transparent !important;',
      '--form-text-color: ' + vars.foreground + ' !important;',
      '--form-field-padding: 0 !important;',
      '--form-field-border: none !important;',
      '--form-field-border-radius: 0 !important;',
      '--forms-body-font: ' + vars.fontFamily + ' normal 14px !important;',
      '--input-label-top: 0 !important;',
      '--input-label-Y-transform: 0 !important;',
      '--input-label-transform: scale(0) !important;',
      '}',
      '* {',
      '  box-sizing: border-box !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '}',
      'form {',
      '  display: flex !important;',
      '  flex-direction: column !important;',
      '  gap: ' + vars.bigMargin + ' !important;',
      '}',
      'label {',
      '  color: ' + vars.gray + ' !important;',
      '  font-size: ' + vars.fontSize + ' !important;',
      '  line-height: ' + vars.lineHeight + ' !important;',
      '  top: 0 !important;',
      '  transition: none !important;',
      '  font-size: 14px !important;',
      '  line-height: 19px !important;',
      '}',
      'div[data-form-root="true"] > div {',
      '  width: 100% !important;',
      '  display: block !important;',
      '}',
      'div {',
      '  box-sizing: border-box !important;',
      '  width: 100% !important;',
      '}',
      'input, textarea {',
      '  all: unset',
      '  box-sizing: border-box !important;',
      '  font-size: ' + vars.fontSize + ' !important;',
      '  line-height: ' + vars.lineHeight + ' !important;',
      '  width: 100% !important;',
      '  border-bottom: 1px solid ' + vars.foreground + ' !important;',
      '  padding: 0 0 5px !important;',
      '}',
      'input:focus-within, textarea:focus-within {',
      '  outline: none !important;',
      '  box-shadow: none !important;',
      '}',
      'textarea {',
      '  resize: vertical !important;',
      '  min-height: 76px !important;',
      '}',
      'div:empty {',
      '  display: none !important;',
      '}',
      'p {',
      '  font-size: ' + vars.fontSize + ' !important;',
      '  line-height: ' + vars.lineHeight + ' !important;',
      '}',
      'div > p {',
      '  display: none !important;',
      '}',
      'button[type="button"] {',
      '  all: unset !important;',
      '  box-sizing: border-box !important;',
      '  cursor: pointer !important;',
      '  max-width: 100% !important;',
      '}',
      'button[type="button"] p, button[type="button"] div {',
      '  background-color: transparent !important;',
      '}',
      'button[type="button"] div {',
      '  display: flex !important;',
      '  justify-content: center !important;',
      '  align-items: center !important;',
      '  gap: 5px !important;',
      '}',
      'button[type="button"] button[type="button"] {',
      '  height: auto !important;',
      '  display: block !important;',
      '  padding: 0 !important;',
      '  line-height: 0 !important;',
      '  position: relative !important;',
      '  top: -1px !important;',
      '}',
      'button[type="button"] span {',
      '  font-size: ' + vars.fontSize + ' !important;',
      '  line-height: ' + vars.lineHeight + ' !important;',
      '  text-overflow: ellipsis !important;',
      '  overflow: hidden !important;',
      '  white-space: nowrap !important;',
      '}',
      'button[type="button"] button[type="button"] svg {',
      '  width: 14px !important;',
      '  height: 14px !important;',
      '  fill: ' + vars.foreground + ' !important;',
      '}',
      'button[type="submit"] {',
      '  all: unset !important;',
      '  box-sizing: border-box !important;',
      '  cursor: pointer !important;',
      '  width: 100% !important;',
      '  margin-top: 50px !important;',
      '  background-color: transparent !important;',
      '  color: ' + vars.gray + ' !important;',
      '  padding: ' + vars.smallMargin + ' ' + vars.margin + ' !important;',
      '  border: 1px solid ' + vars.gray + ' !important;',
      '  display: block !important;',
      '  text-align: center !important;',
      '  font-size: ' + vars.fontSize + ' !important;',
      '  line-height: ' + vars.lineHeight + ' !important;',
      '}',
    ].join('\n');
  }

  function injectStyleIntoShadowRoot(shadowRoot, css) {
    if (!shadowRoot || shadowRoot.querySelector('style[data-ethic-form-injected]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-ethic-form-injected', 'true');
    style.textContent = css;
    shadowRoot.appendChild(style);
  }

  function walkAndInjectShadowRoots(node, css) {
    if (!node) return;
    if (node.shadowRoot) {
      injectStyleIntoShadowRoot(node.shadowRoot, css);
      walkAndInjectShadowRoots(node.shadowRoot, css);
    }
    var children = node.children || node.childNodes;
    for (var i = 0; i < children.length; i++) {
      walkAndInjectShadowRoots(children[i], css);
    }
  }

  function findAndInject(wrapper) {
    if (!wrapper) return;
    var vars = getThemeVars(wrapper);
    var css = buildInjectedCSS(vars);
    walkAndInjectShadowRoots(wrapper, css);
  }

  function run() {
    var wrapper = document.querySelector(wrapperSelector);
    findAndInject(wrapper);
  }

  function runWithRetry(attempts) {
    attempts = attempts || 3;
    run();
    if (attempts > 1) {
      setTimeout(function() { runWithRetry(attempts - 1); }, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(runWithRetry, 100);
    });
  } else {
    setTimeout(runWithRetry, 100);
  }

  // App block may attach shadow root later (e.g. after hydration)
  var wrapper = document.querySelector(wrapperSelector);
  if (wrapper && typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function() { run(); });
    observer.observe(wrapper, { childList: true, subtree: true });
  }
})();
